import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import "./MetlinkReportComponent.css";
import tipsContent from "./tipsContent.json";
import * as MetlinkService from "../../Services/Metlink/MetlinkService";
import { RefreshCcw } from "lucide-react";
import Select from "react-select";
import CommonContainer from "../Container/CommonContainer";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, Legend,
//   CartesianGrid, ResponsiveContainer, LabelList,
// } from "recharts";
import { FaRegFileAlt, FaSpinner } from "react-icons/fa";
import { useSelector } from "react-redux";

const APSCMetlinkReportComponent = () => {
  const userData = useSelector((state) => state.userData);
  const partnerCode = userData?.Partner_Code;

  const [partnerList, setPartnerList] = useState([]);

  const [selectedPartner, setSelectedPartner] = useState(
      partnerCode
      ? { partnerCode }
      : null,
  );
  // const [showReportForm, setShowReportForm] = useState(false);
  const [mtdAchievementData, setMtdAchievementData] = useState({});
  const [monthlyAchievementData, setMonthlyAchievementData] = useState({});
  const [year, setYear] = useState(`${new Date().getFullYear()}-${new Date().getFullYear() + 1}`);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [day, setDay] = useState(null);
  const [recoData, setRecoData] = useState({});
  const [loading, setLoading] = useState(false);
  const [showHierarchyModal, setShowHierarchyModal] = useState(false);
  const [loadingHierarchy, setLoadingHierarchy] = useState(false);
  const [activeCriteriaTab, setActiveCriteriaTab] = useState("points");
  const [activeIncentiveTab, setActiveIncentiveTab] = useState(500);
  const [selectedTipKpi, setSelectedTipKpi] = useState(null);

  const formattedYear = parseInt(year.split("-")[0], 10);
  const formattedMonth = parseInt(month, 10);

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 3 }, (_, i) => {
    const start = currentYear - i;
    return { value: `${start}-${start + 1}`, label: `${start}-${start + 1}` };
  });

  useEffect(() => {
    if (partnerCode) return;

    MetlinkService.GetPartnerList("Retail - APSC")
      .then(({ data }) => {
        if (data.IsSuccess) {
          const partnerData = data.Data.map((item) => ({
            partnerCode: item.Partner_Code,
            didNumber: item.DIDNumber,
          }));
          setPartnerList(partnerData);
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => {
        toast.error("Something went wrong.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [partnerCode]);

  const handleAchievementDetails = () => {
    if (!selectedPartner.partnerCode || !year || !month) {
      toast.error("Please select Partner, Year, and Month first.");
      return;
    }

    setLoading(true);

    MetlinkService.GetMTDAchievementDetails(
      selectedPartner.partnerCode,
      formattedMonth,
      formattedYear,
    )
      .then(({ data }) => {
        if (data.IsSuccess) {
          setMtdAchievementData(data.Data);
          const extractedDay = new Date(data.Data.Month).getDate();
          setDay(extractedDay);
        } else {
          setMtdAchievementData({});
          setDay(null);
        }
      })
      .catch(() => {
        setMtdAchievementData({});
        toast.error("Something went wrong.");
      })
      .finally(() => {
        setLoading(false);
      });

    MetlinkService.GetMonthlyAchievementDetails(
      selectedPartner.partnerCode,
      formattedMonth,
      formattedYear,
      "APSC",
    )
      .then(({ data }) => {
        if (data.IsSuccess) {
          setMonthlyAchievementData(data.Data);
        } else {
          setMonthlyAchievementData({});
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => {
        setMonthlyAchievementData({});
        toast.error("Something went wrong.");
      })
      .finally(() => {
        setLoading(false);
      });

    MetlinkService.GetRecoDetails(
      selectedPartner.partnerCode,
      formattedMonth,
      formattedYear,
    )
      .then(({ data }) => {
        if (data.IsSuccess) {
          setRecoData(data.Data);
        } else {
          setRecoData({});
        }
      })
      .catch(() => {
        setRecoData({});
        toast.error("Something went wrong.");
      });
  };

  useEffect(() => {
    if (selectedPartner?.partnerCode && year && month) {
      handleAchievementDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPartner, year, month]);

  // const performanceData = [
  //   { name: "Revenue", Target: monthlyAchievementData?.Overall_Revenue_Target ?? 0, Achieved: monthlyAchievementData?.Overall_Achieved ?? 0 },
  //   { name: "Wellness", Target: monthlyAchievementData?.Wellness_Target ?? 0, Achieved: monthlyAchievementData?.Wellness_Achieved ?? 0 },
  //   { name: "Google Rating", Target: monthlyAchievementData?.Google_Rating_Target ?? 0, Achieved: monthlyAchievementData?.Google_Rating_Achieved ?? 0 },
  // ];

  const monthlyData = [
    { label: "Select", value: "" },
    { label: "Jan", value: 1 },
    { label: "Feb", value: 2 },
    { label: "Mar", value: 3 },
    { label: "Apr", value: 4 },
    { label: "May", value: 5 },
    { label: "Jun", value: 6 },
    { label: "Jul", value: 7 },
    { label: "Aug", value: 8 },
    { label: "Sep", value: 9 },
    { label: "Oct", value: 10 },
    { label: "Nov", value: 11 },
    { label: "Dec", value: 12 },
  ];

  const selectedMonthLabel =
    monthlyData.find((item) => item.value === month)?.label || "";

  const periodLabel =
    year && month ? `for ${selectedMonthLabel} ${formattedYear}` : "";

  const WEIGHTAGES = {
    googleRating: "5%",
    googleReview: "5%",
    overallRev: "50%",
    wellness: "30%",
    recoConv: "10%",
  };

  const parsePercentage = (pct) => {
    if (!pct) return 0;
    return parseFloat(String(pct).replace("%", "")) || 0;
  };

  const computeKpiScore = (achieved, target) => {
    if (!target || Number(target) === 0) return 0;
    const raw = (Number(achieved ?? 0) / Number(target)) * 100;
    return Math.round(Math.min(raw, 120));
  };

  const computeWeightedAch = (scorePct, weightageStr) => {
    const weightage = parsePercentage(weightageStr);
    if (!weightage) return 0;
    return Math.round(scorePct * weightage / 100);
  };

  const grScore = computeKpiScore(monthlyAchievementData?.Google_Rating_Achieved, monthlyAchievementData?.Google_Rating_Target);
  const grevScore = computeKpiScore(monthlyAchievementData?.Google_Review_Achieved, monthlyAchievementData?.Google_Review_Target);
  const orScore = computeKpiScore(monthlyAchievementData?.Overall_Achieved, monthlyAchievementData?.Overall_Revenue_Target);
  const wrScore = computeKpiScore(monthlyAchievementData?.Wellness_Achieved, monthlyAchievementData?.Wellness_Target);
  const recoScore = computeKpiScore(monthlyAchievementData?.Reco_Conv_Achieved, monthlyAchievementData?.Reco_Conv_Target);

  const totalDaysInMonth =
    formattedYear && formattedMonth
      ? new Date(formattedYear, formattedMonth, 0).getDate()
      : 0;

  const computeRawLanding = (achieved, d = day) =>
    d > 0 && totalDaysInMonth > 0
      ? (Number(achieved ?? 0) / d) * totalDaysInMonth
      : 0;


  const orRawLanding = computeRawLanding(mtdAchievementData?.Or_Achievement);
  const orLanding = parseFloat(orRawLanding.toFixed(2));
  // OR Achievement % = (landing / target - 1) × 100
  const orAchPct = Number(mtdAchievementData?.Or_Target ?? 0) > 0
    ? Math.round(((orRawLanding / Number(mtdAchievementData.Or_Target)) - 1) * 100)
    : 0;

  const wrRawLanding = computeRawLanding(mtdAchievementData?.Wr_Achievement);
  const wrLanding = parseFloat(wrRawLanding.toFixed(2));
  // WR Achievement % = (landing / target - 1) × 100
  const wrAchPct = Number(mtdAchievementData?.Wr_Target ?? 0) > 0
    ? Math.round(((wrRawLanding / Number(mtdAchievementData.Wr_Target)) - 1) * 100)
    : 0;

  const kpiData = [
    {
      name: "Google Rating",
      target: monthlyAchievementData?.Google_Rating_Target ?? 0,
      achieved: monthlyAchievementData?.Google_Rating_Achieved ?? 0,
      score: `${grScore}%`,
      weightedAch: `${computeWeightedAch(grScore, WEIGHTAGES.googleRating)}%`,
    },
    {
      name: "Google Review",
      target: monthlyAchievementData?.Google_Review_Target ?? 0,
      achieved: monthlyAchievementData?.Google_Review_Achieved ?? 0,
      score: `${grevScore}%`,
      weightedAch: `${computeWeightedAch(grevScore, WEIGHTAGES.googleReview)}%`,
    },
    {
      name: "Overall Revenue",
      target: monthlyAchievementData?.Overall_Revenue_Target ?? 0,
      achieved: monthlyAchievementData?.Overall_Achieved ?? 0,
      score: `${orScore}%`,
      weightedAch: `${computeWeightedAch(orScore, WEIGHTAGES.overallRev)}%`,
    },
    {
      name: "TruHealth Revenue",
      target: monthlyAchievementData?.Wellness_Target ?? 0,
      achieved: monthlyAchievementData?.Wellness_Achieved ?? 0,
      score: `${wrScore}%`,
      weightedAch: `${computeWeightedAch(wrScore, WEIGHTAGES.wellness)}%`,
    },
    {
      name: "Reco Conv.",
      target: `${((monthlyAchievementData?.Reco_Conv_Target ?? 0) * 100).toFixed(0)}%`,
      achieved: `${((monthlyAchievementData?.Reco_Conv_Achieved ?? 0) * 100).toFixed(0)}%`,
      score: `${recoScore}%`,
      weightedAch: `${computeWeightedAch(recoScore, WEIGHTAGES.recoConv)}%`,
    },
  ];

  const cumulativeScore = parseFloat(
    (
      computeWeightedAch(grScore, WEIGHTAGES.googleRating) +
      computeWeightedAch(grevScore, WEIGHTAGES.googleReview) +
      computeWeightedAch(orScore, WEIGHTAGES.overallRev) +
      computeWeightedAch(wrScore, WEIGHTAGES.wellness) +
      computeWeightedAch(recoScore, WEIGHTAGES.recoConv)
    ).toFixed(2),
  );

  const computedPoints = (() => {
    if (cumulativeScore <= 90) return 0;
    if (cumulativeScore <= 95) return 100;
    if (cumulativeScore <= 100) return 200;
    if (cumulativeScore <= 110) return 300;
    if (cumulativeScore <= 119) return 400;
    return 500;
  })();

  const tipsMap = {
    "Google Rating": tipsContent.GOOGLE_RATING,
    "Google Review": tipsContent.GOOGLE_REVIEWS,
    "Overall Revenue": tipsContent.REVENUE_TARGET,
    "TruHealth Revenue": tipsContent.WELLNESS_REVENUE,
    "Reco Conv.": tipsContent.RECO,
    "NC": tipsContent.NON_COMPLIANCE_NC,
  };

  const NC_TOTAL = 62;
  const ncNotFulfilled =
    monthlyAchievementData?.NC_Fulfilled != null &&
    Number(monthlyAchievementData.NC_Fulfilled) < NC_TOTAL;

  const scopeOfImprovement = [
    ...kpiData
      .filter((kpi) => parsePercentage(kpi.score) < 100)
      .map((kpi) => kpi.name),
    ...(ncNotFulfilled ? ["NC"] : []),
  ];

  const getMonthlyTip = (kpiName) => {
    const tips = tipsMap[kpiName];
    if (!tips || tips.length === 0) return null;
    const idx = formattedMonth > 0 ? (formattedMonth - 1) % tips.length : 0;
    return tips[idx];
  };

  const starConditions = [
    {
      label: "No NC",
      earned: monthlyAchievementData?.NC_Fulfilled != null && Number(monthlyAchievementData.NC_Fulfilled) >= NC_TOTAL,
    },
    { label: "Overall Rev.", earned: orScore >= 100 },
    { label: "TruHealth Rev.", earned: wrScore >= 100 },
    { label: "Google Rating", earned: grScore >= 100 },
    {
      label: "NPS",
      earned:
        monthlyAchievementData?.NPS_Target != null &&
        Number(monthlyAchievementData.NPS_Target) >= 82,
    },
  ];

  const [hierarchyData, setHierarchyData] = useState([]);

  const getSPOC_Details = (partner_code) => {
    setShowHierarchyModal(true);
    setLoadingHierarchy(true);

    MetlinkService.GetSPOC_Details_ByPartnerCode(partner_code)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setHierarchyData(data?.Data);
        } else {
          setHierarchyData([]);
        }
      })
      .catch(() => {
        setHierarchyData([]);
      })
      .finally(() => setLoadingHierarchy(false));
  };

  const pointsCriteria = [
    { range: "If Cumulative Score < 90%", points: 0 },
    { range: "If Cumulative Score is 91%-95%", points: 100 },
    { range: "If Cumulative Score is 96%-100%", points: 200 },
    { range: "If Cumulative Score is 101%-110%", points: 300 },
    { range: "If Cumulative Score is 111%-119%", points: 400 },
    { range: "If Cumulative Score >= 120%", points: 500 },
  ];

  const incentiveCriteriaData = [
    {
      points: 500,
      color: "#28a745",
      rows: [
        { rev: "0 - 0.3", incentive: 2000 },
        { rev: "0.31 - 0.39", incentive: 3000 },
        { rev: "0.40 - 0.50", incentive: 4000 },
        { rev: "0.51 - 0.60", incentive: 5000 },
        { rev: "0.61 - 1.0", incentive: 6000 },
        { rev: "1.01 - 1.50", incentive: 7000 },
        { rev: "1.50 & above", incentive: 7500 },
      ],
    },
    {
      points: 400,
      color: "#c2185b",
      rows: [
        { rev: "0 - 0.3", incentive: 1500 },
        { rev: "0.31 - 0.50", incentive: 2500 },
        { rev: "0.51 - 0.70", incentive: 3000 },
        { rev: "0.71 & above", incentive: 4000 },
      ],
    },
    {
      points: 300,
      color: "#1565c0",
      rows: [
        { rev: "0 - 0.20", incentive: 1000 },
        { rev: "0.21 - 0.30", incentive: 1500 },
        { rev: "0.31 & above", incentive: 2100 },
      ],
    },
    {
      points: 200,
      color: "#e64a19",
      rows: [
        { rev: "0 - 0.3", incentive: 1000 },
        { rev: "0.31 - 0.50", incentive: 1000 },
        { rev: "0.51 & above", incentive: 1000 },
      ],
    },
  ];

  const computedIncentive = (() => {
    const pts = computedPoints;
    const rev = monthlyAchievementData?.Overall_Achieved ?? 0;
    if (pts === 0 || pts === 100) return 0;
    if (pts === 200) return 1000;
    if (pts === 300) {
      if (rev <= 0.2) return 1000;
      if (rev <= 0.3) return 1500;
      return 2100;
    }
    if (pts === 400) {
      if (rev <= 0.3) return 1500;
      if (rev <= 0.5) return 2500;
      if (rev <= 0.7) return 3000;
      return 4000;
    }
    if (pts === 500) {
      if (rev <= 0.3) return 2000;
      if (rev <= 0.39) return 3000;
      if (rev <= 0.5) return 4000;
      if (rev <= 0.6) return 5000;
      if (rev <= 1) return 6000;
      if (rev <= 1.5) return 7000;
      return 7500;
    }
    return 0;
  })();

  const renderContact = (mobile, email) => {
    if (mobile && email) return `${mobile} / ${email}`;
    if (mobile) return mobile;
    if (email) return email;
    return "—";
  };

  return (
    <CommonContainer
      icon={<FaRegFileAlt size={20} />}
      heading="Partner Details"
    >
      <div className="container-fluid min-vh-100 p-0">
        {/* Controls bar */}
        <div className="bg-white shadow-sm rounded-3 p-3 mb-3">
          <div className="d-flex align-items-center gap-3 metlink-controls-row">
            <div className="d-flex flex-wrap align-items-end gap-3">
              <div>
                <label className="form-label mb-1 fw-semibold">
                  Partner Code
                </label>
                <div className="metlink-partner-select">
                  <Select
                    options={partnerList.map((p) => ({
                      value: p.partnerCode,
                      label: p.partnerCode,
                    }))}
                    placeholder="-- Select --"
                    isSearchable
                    isClearable
                    isDisabled={partnerCode}
                    maxMenuHeight={150}
                    value={
                      selectedPartner
                        ? {
                          value: selectedPartner.partnerCode,
                          label: selectedPartner.partnerCode,
                        }
                        : null
                    }
                    onChange={(option) => {
                      setSelectedPartner(
                        option
                          ? partnerList.find((p) => p.partnerCode === option.value)
                          : null,
                      );
                      if (!option) {
                        setMtdAchievementData({});
                        setMonthlyAchievementData({});
                        setRecoData({});
                        setDay(null);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <label className="form-label mb-1 fw-semibold">Year</label>
                <div className="metlink-year-select">
                  <Select
                    options={yearOptions}
                    placeholder="-- Select --"
                    isSearchable={false}
                    isClearable
                    maxMenuHeight={150}
                    value={year ? { value: year, label: year } : null}
                    onChange={(option) => {
                      setYear(option ? option.value : "");
                      if (!option) {
                        setMtdAchievementData({});
                        setMonthlyAchievementData({});
                        setRecoData({});
                        setDay(null);
                      }
                    }}
                  />
                </div>
              </div>
              <div>
                <label className="form-label mb-1 fw-semibold">Month</label>
                <div className="metlink-month-select">
                  <Select
                    options={monthlyData
                      .filter((item) => item.value !== "")
                      .map((item) => ({
                        value: item.value,
                        label: item.label,
                      }))}
                    placeholder="-- Select --"
                    isSearchable={false}
                    isClearable
                    maxMenuHeight={150}
                    value={
                      month
                        ? {
                          value: month,
                          label: monthlyData.find(
                            (item) => item.value === month,
                          )?.label,
                        }
                        : null
                    }
                    onChange={(option) => {
                      setMonth(option ? option.value : "");
                      if (!option) {
                        setMtdAchievementData({});
                        setMonthlyAchievementData({});
                        setRecoData({});
                        setDay(null);
                      }
                    }}
                  />
                </div>
              </div>
              <button
                onClick={handleAchievementDetails}
                disabled={loading || !selectedPartner}
                className="btn custom-sumbitbtn d-flex align-items-center justify-content-center metlink-refresh-btn"
              >
                {loading ? (
                  <FaSpinner className="fa-spin" />
                ) : (
                  <RefreshCcw size={20} color="white" />
                )}
              </button>
            </div>{/* end flex-grow-1 */}

            {/* Performance stars */}
            <div className="metlink-perf-stars-wrapper">
              <div className="border border-primary-custom rounded p-2 text-center">
                <h6 className="text-primary-custom mb-1 metlink-perf-month-title">Performance of the month</h6>
                <div className="d-flex gap-2 justify-content-around">
                  {starConditions.map(({ label, earned }, i) => (
                    <div key={i} className="d-flex flex-column align-items-center gap-1">
                      <i className={`fas fa-star metlink-star-icon ${earned ? "text-warning" : "metlink-star-unearned"}`}></i>
                      <span className="metlink-star-label">{label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>{/* end outer flex */}
        </div>

        {/* Info bar */}
        <div className="bg-white shadow-sm rounded-3 p-3 mb-4">
          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <div className="metlink-stat-icon-wrap">
                <i className="fas fa-trophy"></i>
              </div>
              <div>
                <div className="metlink-stat-label">Cumulative Points (YTD)</div>
                <div className="metlink-stat-value">{monthlyAchievementData?.Ytd_Points ?? 0}</div>
              </div>
            </div>
            <div className="border border-primary-custom rounded p-2 d-flex gap-3 align-items-center">
              <div className="d-flex align-items-center gap-2">
                <div className="metlink-stat-icon-wrap fw-bold">₹</div>
                <div>
                  <div className="metlink-stat-label">Eligible Incentive</div>
                  <div className="metlink-stat-value">₹{computedIncentive.toLocaleString()}</div>
                </div>
              </div>
              <div className="vr"></div>
              <div className="d-flex align-items-center gap-2">
                <div className="metlink-stat-icon-wrap fw-bold">₹</div>
                <div>
                  <div className="metlink-stat-label d-flex align-items-center gap-1">
                    Incentive Disbursed
                    {ncNotFulfilled && (
                      <span className="metlink-tooltip-wrap">
                        <i className="fas fa-exclamation-circle text-danger" style={{ fontSize: "0.75rem" }}></i>
                        <span className="metlink-tooltip-text">NC is not fulfilled</span>
                      </span>
                    )}
                  </div>
                  <div className="metlink-stat-value">
                    {ncNotFulfilled ? "₹0" : `₹${computedIncentive.toLocaleString()}`}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="metlink-stat-label">DID Number</div>
              <div className="metlink-stat-value">
                {monthlyAchievementData?.DIDNumber || selectedPartner?.didNumber || "—"}
              </div>
            </div>
            {selectedPartner && (
              <button
                className="btn btn-sm custom-sumbitbtn"
                onClick={() => getSPOC_Details(selectedPartner?.partnerCode)}
              >
                View SPOC Details
              </button>
            )}
          </div>
        </div>

        {/* TSM / ZSM / BU Head Modal */}
        {showHierarchyModal && (
          <>
            <div className="modal-backdrop"></div>
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
            >
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header p-2 ml-1">
                    <h5 className="modal-title">TSM / ZSM / BU Head Details</h5>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={() => setShowHierarchyModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {loadingHierarchy ? (
                      <div className="d-flex justify-content-center align-items-center py-4">
                        <div className="spinner-border text-success" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                    <div className="border border-primary-custom rounded p-0">
                      <table className="table table-sm mb-0 table-bordered custom-table">
                        <thead className="bg-light">
                          <tr>
                            <th className="text-nowrap">SPOC</th>
                            <th>Name</th>
                            <th className="text-nowrap">Contact</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="fw-bold">TSM</td>
                            <td>{hierarchyData[0]?.Owner?.Name || "—"}</td>
                            {/* <td>{hierarchyData[0]?.Owner?.MobilePhone || "—"} / {hierarchyData[0]?.Owner?.Email || "—"}</td> */}
                            <td>
                            {renderContact(
                              hierarchyData[0]?.Owner?.MobilePhone,
                              hierarchyData[0]?.Owner?.Email
                            )}
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-bold">ZSM</td>
                            <td>{hierarchyData[0]?.Owner?.Manager?.Name || "—"}</td>
                            {/* <td>{hierarchyData[0]?.Owner?.Manager?.MobilePhone || "—"} / {hierarchyData[0]?.Owner?.Manager?.Email || "—"}</td> */}
                            <td>
                            {renderContact(
                              hierarchyData[0]?.Owner?.Manager?.MobilePhone,
                              hierarchyData[0]?.Owner?.Manager?.Email
                            )}
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-bold">BU Head</td>
                            <td>{hierarchyData[0]?.Owner?.Manager?.Manager?.Name || "—"}</td>
                            <td>{hierarchyData[0]?.Owner?.Manager?.Manager?.Email || "—"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    )}
                  </div>
                  <div className="modal-footer p-2">
                    <button
                      className="btn btn-danger"
                      onClick={() => setShowHierarchyModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="container-fluid">

          {/* Summary banners */}
          <div className="row mb-3">
            <div className="col-md-6 mb-3 mb-md-0">
              <div className="bg-primary-light p-3 rounded">
                <strong>Your cumulative score for this month is {cumulativeScore}%.</strong>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bg-primary-light p-3 rounded">
                <strong>
                  Your cumulative points for this month is{" "}
                  <span className="text-primary-custom">{computedPoints}</span>
                </strong>
              </div>
            </div>
          </div>

          {/* Row 1: KPIs + SOI (stacked left) | MTD OR + MTD WR (stacked right) */}
          <div className="row mb-3">
            <div className="col-md-6 d-flex flex-column gap-3">
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">KPIs Score {periodLabel}</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-metlink table-bordered table-sm mb-0 custom-table">
                      <thead className="bg-light">
                        <tr>
                          <th>KPIs</th>
                          <th>Target</th>
                          <th>Achieved</th>
                          <th>Score %</th>
                          <th>Total Score</th>
                        </tr>
                      </thead>
                      <tbody>
                        {kpiData.map((kpi, index) => (
                          <tr key={index}>
                            <td className="fw-bold">{kpi.name}</td>
                            <td>{kpi.target}</td>
                            <td>{kpi.achieved}</td>
                            <td>{kpi.score}</td>
                            {index === 0 && (
                              <td rowSpan={5} className="text-center align-middle fs-1 fw-bold">
                                {cumulativeScore}%
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="bg-primary-light rounded p-3">
                <h6 className="text-center mb-3">Scope of Improvement:</h6>
                <div className="d-flex flex-wrap gap-2 justify-content-center">
                  {scopeOfImprovement.length > 0 ? (
                    scopeOfImprovement.map((item, i) => (
                      <button
                        key={i}
                        className="btn btn-sm metlink-improvement-btn"
                        onClick={() => setSelectedTipKpi(item)}
                      >
                        {item}
                        <i className="fas fa-lightbulb ms-1 metlink-tip-icon"></i>
                      </button>
                    ))
                  ) : (
                    <span className="text-muted">Great job! You're doing everything right!</span>
                  )}
                </div>
              </div>
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">Non Compliance Status</h6>
                </div>
                <div className="card-body d-flex flex-column justify-content-between">
                  <div className="table-responsive">
                    <table className="table table-metlink table-bordered table-sm mb-0 custom-table">
                      <thead className="bg-light">
                        <tr>
                          <th className="text-center">Total Non Compliances</th>
                          <th className="text-center">Non Compliances Fulfilled</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center fs-4 fw-bold text-primary-custom">{NC_TOTAL}</td>
                          <td className="text-center fs-4 fw-bold text-primary-custom">{monthlyAchievementData?.NC_Fulfilled ?? 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="metlink-disclaimer mt-3">
                    <strong>Disclaimer:</strong> Incentive payouts are applicable only upon successful closure of NC.
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">NPS Score Criteria</h6>
                </div>
                <div className="card-body">
                  <div className="border border-primary-custom rounded p-3 text-center">
                    <div className="fw-bold mb-2">NPS Score</div>
                    <div>If NPS Score = 88, one star will be awarded</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex flex-column gap-3">
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">MTD Overall Revenue Achievements {periodLabel}</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-metlink table-bordered table-sm mb-0 custom-table">
                      <thead className="bg-light">
                        <tr>
                          <th className="metlink-col-day">Day</th>
                          <th className="metlink-col-mtd">OR Target</th>
                          <th className="metlink-col-mtd">OR Achieved</th>
                          <th className="metlink-col-mtd">Remaining Target</th>
                          <th className="metlink-col-mtd">Daily Revenue Target</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{day ?? 0}</td>
                          <td>{mtdAchievementData?.Or_Target ?? 0}</td>
                          <td>{mtdAchievementData?.Or_Achievement ?? 0}</td>
                          <td>{parseFloat((Number(mtdAchievementData?.Or_Target ?? 0) - Number(mtdAchievementData?.Or_Achievement ?? 0)).toFixed(2))}</td>
                          <td>{parseFloat((Math.max(Number(mtdAchievementData?.Or_Target ?? 0) - Number(mtdAchievementData?.Or_Achievement ?? 0), 0) / (Math.max(totalDaysInMonth - (day ?? 0), 1))).toFixed(2))}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">MTD TruHealth Revenue Achievements {periodLabel}</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-metlink table-bordered table-sm mb-0 custom-table">
                      <thead className="bg-light">
                        <tr>
                          <th className="metlink-col-day">Day</th>
                          <th className="metlink-col-mtd">WR Target</th>
                          <th className="metlink-col-mtd">WR Achieved</th>
                          <th className="metlink-col-mtd">Remaining Target</th>
                          <th className="metlink-col-mtd">Daily TruHealth Target</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{day ?? 0}</td>
                          <td>{mtdAchievementData?.Wr_Target ?? 0}</td>
                          <td>{mtdAchievementData?.Wr_Achievement ?? 0}</td>
                          <td>{parseFloat((Number(mtdAchievementData?.Wr_Target ?? 0) - Number(mtdAchievementData?.Wr_Achievement ?? 0)).toFixed(2))}</td>
                          <td>{parseFloat((Math.max(Number(mtdAchievementData?.Wr_Target ?? 0) - Number(mtdAchievementData?.Wr_Achievement ?? 0), 0) / (Math.max(totalDaysInMonth - (day ?? 0), 1))).toFixed(2))}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">Reco Engine Performance</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-metlink table-sm mb-0 table-bordered custom-table">
                      <thead className="bg-light">
                        <tr>
                          <th className="text-center">Day</th>
                          <th className="text-center">Total Walk-in</th>
                          <th className="text-center">Clicks Walk-in</th>
                          <th className="text-center">Conv. Walk-in</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">
                            {recoData?.Month ? new Date(recoData.Month).getDate() : day ?? 0}
                          </td>
                          <td className="text-center">{recoData?.Total_Walkin ?? 0}</td>
                          <td className="text-center">
                            {recoData?.Total_Walkin > 0
                              ? `${Math.round((recoData.Clicks / recoData.Total_Walkin) * 100)}%`
                              : "0%"}
                          </td>
                          <td className="text-center">
                            {recoData?.Total_Walkin > 0
                              ? `${Math.round((recoData.Converted_Count / recoData.Total_Walkin) * 100)}%`
                              : "0%"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="metlink-card-header bg-primary-custom text-white text-center">
                  <h6 className="mb-0">Incentive Calculation</h6>
                </div>
                <div className="d-flex border-bottom">
                  <button
                    className={`metlink-criteria-tab flex-fill${activeCriteriaTab === "points" ? " active" : ""}`}
                    onClick={() => setActiveCriteriaTab("points")}
                  >
                    Points Criteria
                  </button>
                  <button
                    className={`metlink-criteria-tab flex-fill${activeCriteriaTab === "incentive" ? " active" : ""}`}
                    onClick={() => setActiveCriteriaTab("incentive")}
                  >
                    Incentive Criteria
                  </button>
                </div>
                <div className="card-body">
                  {activeCriteriaTab === "points" ? (
                    <div className="table-responsive border border-primary-custom rounded p-0">
                      <table className="table table-metlink table-sm mb-0 table-bordered custom-table">
                        <thead className="bg-light">
                          <tr>
                            <th>Points Criteria</th>
                            <th className="text-center">Points</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pointsCriteria.map((criteria, index) => (
                            <tr key={index}>
                              <td>{criteria.range}</td>
                              <td className="text-center">{criteria.points}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <>
                      <div className="d-flex border-bottom mb-3">
                        {incentiveCriteriaData.map((group) => (
                          <button
                            key={group.points}
                            className={`metlink-incentive-tab flex-fill${activeIncentiveTab === group.points ? " active" : ""}`}
                            onClick={() => setActiveIncentiveTab(group.points)}
                          >
                            {group.points}
                          </button>
                        ))}
                      </div>
                      {incentiveCriteriaData
                        .filter((g) => g.points === activeIncentiveTab)
                        .map((group) => (
                          <div key={group.points} className="border border-primary-custom rounded p-0">
                            <table className="table table-sm mb-0 table-bordered custom-table">
                              <thead>
                                <tr>
                                  <th className="text-center bg-light">Revenue</th>
                                  <th className="text-center bg-light">Incentive (₹)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {group.rows.map((row, i) => (
                                  <tr key={i}>
                                    <td>{row.rev}</td>
                                    <td className="text-center">{row.incentive.toLocaleString()}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ))}
                    </>
                  )}
                  <div className="metlink-disclaimer mt-3">
                    <strong>Disclaimer:</strong> There is a 120% capping on Cumulative score.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Improvement Tip Modal */}
      {selectedTipKpi && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-sm" role="document">
              <div className="modal-content">
                <div className="modal-header metlink-card-header">
                  <h6 className="modal-title text-white mb-0">
                    <i className="fas fa-lightbulb me-2"></i>
                    {selectedTipKpi}
                  </h6>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setSelectedTipKpi(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p className="mb-0 metlink-tip-text">
                    {getMonthlyTip(selectedTipKpi) ?? "Tip not available for this KPI."}
                  </p>
                </div>
                <div className="modal-footer p-2">
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => setSelectedTipKpi(null)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </CommonContainer>
  );
};

export default APSCMetlinkReportComponent;
